import { supabase } from '../supabaseClient';

// 跨日快取
let cachedCompanies = null;
let cacheDate = null;

function ensureCacheDate() {
  const today = new Date().toISOString().slice(0, 10);
  if (cacheDate !== today) {
    cachedCompanies = null;
    cacheDate = today;
  }
}

// 請求去重：短時間內多次呼叫只發一個請求
let _companiesPromise = null;

// 取得所有公司（直查 DB + 跨日 cache）
// 註：主系統 API 對非 super_admin 只回傳自己的公司，
// 但 PMS 的呼叫端都已做角色檢查（只有 super_admin 使用 company switcher），所以這裡不加過濾
export const getAllCompanies = async () => {
  ensureCacheDate();

  if (cachedCompanies) {
    return { data: cachedCompanies, error: null };
  }

  if (_companiesPromise) {
    return _companiesPromise;
  }

  _companiesPromise = (async () => {
    try {
      const { data, error } = await supabase
        .from('companies')
        .select('*')
        .order('name');

      if (error) {
        _companiesPromise = null;
        return { data: null, error };
      }

      cachedCompanies = data || [];
      _companiesPromise = null;
      return { data: cachedCompanies, error: null };
    } catch (error) {
      _companiesPromise = null;
      console.error('Error fetching companies:', error);
      return { data: null, error };
    }
  })();

  return _companiesPromise;
};

// 取得單一公司
export const getCompanyById = async (id) => {
  try {
    // 先從 cache 找
    ensureCacheDate();
    if (cachedCompanies) {
      const company = cachedCompanies.find(c => c.id === id) || null;
      return { data: company, error: null };
    }

    const { data, error } = await supabase
      .from('companies')
      .select('*')
      .eq('id', id)
      .single();
    return { data, error };
  } catch (error) {
    console.error('Error fetching company:', error);
    return { data: null, error };
  }
};
